import { RefreshCw } from "lucide-react";
import { ScrollArea } from "../ui/scroll-area";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../ui/table";

export function OddsTable({
  raceData,
  loading,
  selectedHorseForSuper,
  onHorseSelect
}) {
  if (!raceData || !raceData.horses) {
    return (
      <div className="flex items-center justify-center h-64 text-[#94A3B8]">
        {loading ? (
          <div className="flex items-center gap-3">
            <RefreshCw className="w-6 h-6 animate-spin" />
            <span>Laster odds...</span>
          </div>
        ) : (
          <span>Velg et spill og løp for å se odds</span>
        )}
      </div>
    );
  }

  return (
    <ScrollArea className="flex-1 p-4">
      <Table data-testid="odds-table">
        <TableHeader>
          <TableRow className="border-[#334155] hover:bg-transparent">
            <TableHead className="text-[#94A3B8]">#</TableHead>
            <TableHead className="text-[#94A3B8]">Hest</TableHead>
            <TableHead className="text-[#94A3B8]">Kusk</TableHead>
            <TableHead className="text-[#94A3B8] text-right">Innsats %</TableHead>
            <TableHead className="text-[#94A3B8] text-center">Super</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {raceData.horses
            .sort((a, b) => b.distribution - a.distribution)
            .map((horse) => (
              <TableRow 
                key={horse.number} 
                className={`border-[#334155] hover:bg-[#1E293B] cursor-pointer ${selectedHorseForSuper?.number === horse.number ? 'bg-yellow-900/30' : ''}`}
                data-testid={`horse-row-${horse.number}`}
                onClick={() => onHorseSelect(horse)}
              >
                <TableCell>
                  <span className="inline-flex items-center justify-center w-8 h-8 bg-white text-black font-mono font-bold rounded">
                    {horse.number}
                  </span>
                </TableCell>
                <TableCell>
                  <div>
                    <p className="font-semibold text-white">{horse.name}</p>
                    <p className="text-xs text-[#94A3B8]">{horse.trainer}</p>
                  </div>
                </TableCell>
                <TableCell className="text-[#94A3B8]">{horse.driver}</TableCell>
                <TableCell className="text-right">
                  <div className="flex flex-col items-end gap-1">
                    <span className="font-mono text-green-400">
                      {horse.distribution > 0 ? `${horse.distribution.toFixed(1)}%` : '-'}
                    </span>
                    {horse.distribution > 0 && (
                      <div className="w-24 h-1.5 bg-[#1E293B] rounded-full overflow-hidden">
                        <div 
                          className="h-full bg-green-500 rounded-full transition-all"
                          style={{ width: `${Math.min(horse.distribution, 100)}%` }}
                        />
                      </div>
                    )}
                  </div>
                </TableCell>
                <TableCell className="text-center">
                  {selectedHorseForSuper?.number === horse.number && (
                    <span className="inline-flex items-center justify-center w-6 h-6 bg-yellow-500 text-black font-bold rounded text-xs">
                      S
                    </span>
                  )}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </ScrollArea>
  );
}
